import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=2f9b76e3&scoped=true&"
import script from "./CustomPagination.vue?vue&type=script&lang=js&"
export * from "./CustomPagination.vue?vue&type=script&lang=js&"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=2f9b76e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b76e3",
  null
  
)

export default component.exports